import { createStore, createLogger } from "vuex";
import { application } from "@/store/modules/application.store";
import { auth } from "@/store/modules/auth.store";
import { contactBook } from "@/store/modules/contactBook.store";
import { staticData } from "@/store/modules/staticData.store";

export const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    application,
    auth,
    contactBook,
    staticData,
  },
  plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : [],
});
